import {Component, EventEmitter, inject, Input, OnInit, Output} from '@angular/core';
import {SpectrumProcedureStep} from '../../core/definitions/setting-spectrum-procedure';
import {OperationContainer} from '../../core/definitions/operation-container';
import {PrimusStateMapperService} from '../../core/primus-state-mapper.service';
import {PrimusRouterService} from '../../core/primus-router.service';

@Component({
    selector: 'app-procedure-stepper',
    templateUrl: './procedure-stepper.component.html',
    styleUrls: ['./procedure-stepper.component.scss'],
    standalone: false
})
export class ProcedureStepperComponent implements OnInit{
  // Injections
  public primusStateMapper: PrimusStateMapperService = inject(PrimusStateMapperService);
  private readonly primusRouter: PrimusRouterService = inject(PrimusRouterService);

  @Input() isEditing: boolean;
  @Input() operationContainer: OperationContainer;
  @Input() procedureSteps: SpectrumProcedureStep[];
  @Input() currentProcedureStep: SpectrumProcedureStep;
  @Output() stepSelected = new EventEmitter<SpectrumProcedureStep>();

  currentState: string;

  ngOnInit() {
    this.currentState = this.primusRouter.currentState();
  }

  setCurrentStepperMenu(step: SpectrumProcedureStep) {
    this.stepSelected.emit(step);
  }

  getCount(step: SpectrumProcedureStep) {
    let res = 0;
    if (step.contentListSource.searchContainer?.searchResult?.search_count) {
      res = step.contentListSource.searchContainer?.searchResult?.search_count;
    } else if (step.contentListSource.array.length) {
      res = step.contentListSource.array.length
    }
    return res;
  }

}
